import { useDispatch } from 'react-redux';

import { openUploadModal } from 'components/Layouts/Form/FormBuilder/Content/AddNewContent/uploadModal';
import Image from 'components/shared/Icon/icons/Image';
import NewPDF2 from 'components/shared/Icon/icons/NewPDF2';
import Trash2 from 'components/shared/Icon/icons/Trash2';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { EBlockType, IBlock } from 'detailsv2/__blocks';
import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import { usePageContext } from 'detailsv2/LandingV2/Page/context';
import useAssetsPermissions from 'hooks/useAssetsPermissions';

import { useBlockContext } from '../../../Block/context';
import { getModalTitleText } from '../../../functions';
import styles from './index.module.css';

export const useSmMenu = (hasDocumentButton?: boolean, hasImageButton?: boolean, hiddenTrash?: boolean) => {
  type ImageOrDocument = IBlock<EBlockType.Image> | IBlock<EBlockType.Document>;
  const { onDelete, block, onUpdate } = useBlockContext<ImageOrDocument>();

  const dispatch = useDispatch();
  const { data: landingData } = usePageContext();
  const { data: page } = useLandingV2Context();
  const { data: blockData } = block;

  const isItinerariesItem = landingData.type === ITINERARIES_ITEM_TYPES.ITINERARY;
  const currentPage = isItinerariesItem ? landingData : page;
  const { withAssetSettings } = useAssetsPermissions();

  const openModal = async (type: string) => {
    const modalTitle = getModalTitleText(type);
    // @ts-ignore
    const assets = await openUploadModal(dispatch, {
      type,
      suggested: currentPage,
      modalTitle,
      selected: blockData.files,
      isSortingEnabled: true,
      isItinerariesItem,
      withAssetSettings,
      defaults: {
        name: 'name' in currentPage ? currentPage.name : null,
        tags: 'tags' in currentPage ? currentPage.tags : null,
      },
    });

    if (assets === null) {
      return;
    }

    const newObject = {
      ...block,
      data: {
        ...block.data,
        files: assets,
      },
    };

    onUpdate?.<ImageOrDocument>(newObject);
  };

  const getItems = () => {
    const res = [];

    if (!hiddenTrash) {
      res.push({ icon: Trash2, className: styles.trashIcon, onClick: onDelete });
    }

    if (hasImageButton) {
      res.unshift({
        icon: Image,
        text: 'Images',
        className: styles.imagesIcon,
        onClick: () => openModal('media'),
        block: true,
      });
    }

    if (hasDocumentButton) {
      res.unshift({
        icon: NewPDF2,
        text: 'PDF',
        className: styles.documentIcon,
        onClick: () => openModal('document'),
        block: true,
      });
    }
    return res;
  };
  const items = getItems();

  return { items };
};
